import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

const Register = () => {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    city: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    setLoading(true);
    try {
      const user = await register({
        first_name: form.first_name,
        last_name: form.last_name,
        email: form.email,
        phone: form.phone,
        password: form.password,
        city: form.city,
      });
      toast.success(`Inscription réussie ! Bienvenue, ${user.first_name}.`);
      navigate('/patient');
    } catch (err) {
      const msg = err.response?.data?.message || 'Erreur lors de l\'inscription.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ maxWidth: 520 }}>
        <div className="auth-header">
          <div className="auth-logo">N</div>
          <h1>Créer un compte</h1>
          <p>Rejoignez NomargueriPay pour gérer vos factures médicales</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Prénom *</label>
              <input type="text" name="first_name" className="form-input" placeholder="Votre prénom"
                value={form.first_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Nom *</label>
              <input type="text" name="last_name" className="form-input" placeholder="Votre nom"
                value={form.last_name} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Email *</label>
            <input type="email" name="email" className="form-input" placeholder="exemple@email.com"
              value={form.email} onChange={handleChange} required />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Téléphone *</label>
              <input type="tel" name="phone" className="form-input" placeholder="+243 8XX XXX XXX"
                value={form.phone} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Ville</label>
              <input type="text" name="city" className="form-input" placeholder="Kinshasa, Lubumbashi..."
                value={form.city} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Mot de passe *</label>
              <input type="password" name="password" className="form-input" placeholder="Min. 6 caractères"
                value={form.password} onChange={handleChange} required minLength={6} />
            </div>
            <div className="form-group">
              <label className="form-label">Confirmer *</label>
              <input type="password" name="confirmPassword" className="form-input" placeholder="Confirmer"
                value={form.confirmPassword} onChange={handleChange} required minLength={6} />
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Inscription...' : 'S\'inscrire'}
          </button>
        </form>

        <div className="auth-footer">
          Déjà un compte ? <Link to="/login">Se connecter</Link>
        </div>
      </div>
    </div>
  );
};

export default Register;
